import { createSlice } from '@reduxjs/toolkit';
import { HELPSECTIONTOPICS } from '../../utils/Constants';

const initialState = { show: false, comingFrom: '' };

const slice = createSlice({
  name: 'helpSection',
  initialState: initialState,
  reducers: {
    openHelpSection: (state, { payload }) => ({
      show: payload.show,
      comingFrom: payload.comingFrom || HELPSECTIONTOPICS.CONTACTUS,
    }),
    closeHelpSection: () => ({ ...initialState }),
  },
});

export const { openHelpSection, closeHelpSection } = slice.actions;

export default slice.reducer;
